import React from 'react';
import Utilities from '../utilities/MasterHeader'
import WhatDo from '../components/WhatDo'
import Philosophy from '../components/Philosophy'
import Splittel from '../components/Splittel'
import Footer from '../components/Footer'
import WikiContent from '../components/wiki_content'
import WikiTemario from '../components/wiki_temario'
const Wiki = () => {
    return (
        <div>
            <Utilities />
            <WikiContent />
            <WikiTemario />
            <Footer />
        </div>
    );
};

export default Wiki;
